<!-- main banner  -->
<div class="collab-banner sticky-header-banner banner-sec black-text">
    <div class="container">
        <div class="sec-padding m-col-width mt-negative">
           
            <div class="z-index pb-2">
                <div class="row mx-0 m-col-width">
                    <div class="col-md-6 col-sm-12 px-0 m-mb d-flex flex-column justify-content-center">        
                        <h1 class="banner-heading mw-600">{{'setGoals.banner.headline1' | translate}} {{'setGoals.banner.headline2' | translate}} <br> {{'setGoals.banner.headline3' | translate}} {{'setGoals.banner.headline4' | translate}}</h1>
                        <p class="paragraph-global-text mw-500 fw-500">{{'setGoals.banner.tagline' | translate}}</p>
                        <p class="paragraph-global-text mw-500">{{'setGoals.banner.subheadline' | translate}}</p>
                    </div>
                    <div class="col-md-6 col-sm-12 pr-0 d-flex align-items-center">
                        <figure>
                            <img class="w-100 pl-4" width="300" src="../../../assets/icons/find-answers/find-answer-banner.svg" alt="find answers">
                        </figure>
                    </div>
                </div>                
            </div>           
        </div>
    </div>
  </div>


  <div class="sec-padding">
    <div class="container">
        <div class="row mx-0 m-col-width m-flex-column-reverce">
            <div class="col-md-6 col-sm-12 d-flex align-items-center">
                <div class="feature-content-padding">
                     <h3 class="heading-two mw-450">{{"setGoals.understanding.section1.title" | translate}}</h3>
                     <p class="paragraph-global-text mb-4 mw-500">{{"setGoals.understanding.section1.description" | translate}}</p>
                     <h3 class="heading-two mw-450">{{"setGoals.understanding.section2.title" | translate}}</h3>
                     <p class="paragraph-global-text mw-500">{{"setGoals.understanding.section2.description" | translate}}</p>
                </div>
             </div>
            <div class="col-md-6 col-sm-12 m-mb">
                <figure>
                    <img class="w-100" src="../../assets/icons/Homepage/features/features.svg" alt="">
                </figure>
            </div>            
        </div>
    </div>
  </div>


  <div class="sec-padding section_bg">
    <div class="container">
        <div class="sec-title pb-3 text-center">
            <h2 class="heading-one mx-auto mb-5 mw-800">{{"setGoals.twoways.title" | translate}} {{"setGoals.twoways.title2" | translate}} </h2>
            <div>
                <div class="sug-heading-tag mx-auto mb-5"><h3 class="heading-two primary-color mb-0">{{'setGoals.twoways.first.title' | translate}}</h3></div>
            </div>
            <p class="paragraph-global-text"><span class="fw-500">{{"setGoals.twoways.first.preDescription" | translate}}</span> {{"setGoals.twoways.first.description" | translate}}</p>
            <h3 class="heading-two mx-auto mt-5 pt-4 mb-0">{{'setGoals.twoways.first.subHeading' | translate}}</h3>
        </div>
        <div class="row mx-0 m-col-width">
            <div class="col-md-3 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto"> 
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text icon-primary-color"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M10 9H8"/><path d="M16 13H8"/><path d="M16 17H8"/></svg>
                    </div>
                     <h4 class="heading-three pt-4">{{'setGoals.twoways.first.section1.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'setGoals.twoways.first.section1.description' | translate}}</p>
                </div>
             </div>
             <div class="col-md-3 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto"> 
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-user-check icon-primary-color"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><polyline points="16 11 18 13 22 9"/></svg>
                    </div>
                     <h4 class="heading-three pt-4">{{'setGoals.twoways.first.section2.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'setGoals.twoways.first.section2.description' | translate}}</p>
                </div>
             </div>
             <div class="col-md-3 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto"> 
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lock icon-primary-color"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                    </div>
                     <h4 class="heading-three pt-4">{{'setGoals.twoways.first.section3.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'setGoals.twoways.first.section3.description' | translate}}</p>
                </div>
             </div>
             <div class="col-md-3 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto"> 
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-trending-up icon-primary-color"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>
                    </div>
                     <h4 class="heading-three pt-4">{{'setGoals.twoways.first.section4.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'setGoals.twoways.first.section4.description' | translate}}</p>
                </div>
             </div>
        </div>
        <div class="mt-5 pt-4">
            <div class="highlighted-div mw-600 mx-auto flex-wrap text-center">
               <p class="paragraph-global-text text-white mb-0"> <span class="fw-500">{{'setGoals.twoways.keyBenefit' | translate}}</span> {{'setGoals.twoways.first.tagline' | translate}}</p>
            </div>
        </div>
    </div>
  </div>

  <!-- why amy section  -->
<div class="sec-padding why-amy-sec">
    <div class="container position-relative">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-two primary-color mx-auto">{{"setGoals.twoways.two.title" | translate}} </h2>
            <p class="paragraph-global-text"><span class="fw-500">{{"setGoals.twoways.two.preDescription" | translate}}</span> {{"setGoals.twoways.two.description" | translate}}</p>
        </div>
        <div class="row mx-0 m-col-width">
            <div class="col-md-4 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards">
                     <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-target icon-primary-color"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>
                     </div>
                     <h4 class="heading-three pt-4">{{'setGoals.twoways.two.section1.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'setGoals.twoways.two.section1.description' | translate}}</p>
                </div>
             </div>
             <div class="col-md-4 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-user-check icon-primary-color"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><polyline points="16 11 18 13 22 9"/></svg>
                    </div>
                     <h4 class="heading-three pt-4">{{'setGoals.twoways.two.section2.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'setGoals.twoways.two.section2.description' | translate}}</p>
                </div>
             </div>
             <div class="col-md-4 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lock icon-primary-color"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                    </div>
                     <h4 class="heading-three pt-4">{{'setGoals.twoways.two.section3.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'setGoals.twoways.two.section3.description' | translate}}</p>
                </div>
             </div>
             <div class="col-md-4 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chart-no-axes-column-increasing icon-primary-color"><line x1="12" x2="12" y1="20" y2="10"/><line x1="18" x2="18" y1="20" y2="4"/><line x1="6" x2="6" y1="20" y2="16"/></svg>
                    </div>
                     <h4 class="heading-three pt-4">{{'setGoals.twoways.two.section4.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'setGoals.twoways.two.section4.description' | translate}}</p>
                </div>
             </div>
             <div class="col-md-4 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards">
                    <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-calendar icon-primary-color"><path d="M8 2v4"/><path d="M16 2v4"/><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M3 10h18"/></svg>
                    </div>
                     <h4 class="heading-three pt-4">{{'setGoals.twoways.two.section5.title' | translate}}</h4>
                     <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">{{'setGoals.twoways.two.section5.description' | translate}}</p>
                </div>
             </div>
        </div>
        <div class="mt-5 pt-4">
            <div class="highlighted-div mw-600 mx-auto flex-wrap text-center">
               <p class="paragraph-global-text text-white mb-0"> <span class="fw-500">{{'setGoals.twoways.keyBenefit' | translate}}</span> {{'setGoals.twoways.two.tagline' | translate}}</p>
            </div>
        </div>
    </div>
  </div>


<!-- c f a    -->
<div class="sec-padding cfa-sec position-relative">    
    <div class="cfa-grid"></div>
    <div class="container z-index">
        <div class="sec-title text-center">
            <h2 class="heading-one text-white mx-auto">{{'setGoals.cfa.title' | translate}} </h2>
            <p class="paragraph-global-text sub-head-paragraph mw-650 text-white">{{'setGoals.cfa.description' | translate}}</p>
  
            <div class="button-container mt-4">
                <a class="save-btn cfa btn" [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                    {{'setGoals.cfa.buttonTxt' | translate}}
                </a>
            </div>
        </div>
    </div>
  </div>